<template>
  <template v-if="isPriceProps(facet) && isValidPriceValue(facet)">
    <FacetTagPrice
      :value="[facet.value?.[0] ?? 1000, facet.value?.[1] ?? 100]"
      @click="handleOnSelectItem(facet, null)"
    />
  </template>

  <template v-if="isSelectProps(facet)">
    <FacetTagSelect
      v-for="value in facet.value"
      :key="value.value"
      :label="`${facet.label}: ${value.label}`"
      @click="handleOnSelectItem(facet, value.value)"
    />
  </template>

  <template v-if="isAggregationOption(facet.value) && isToggleProps(facet)">
    <FacetTagSelect
      :label="`${facet.label}`"
      @click="() => isAggregationOption(facet.value) && handleOnSelectItem(facet, facet?.value?.value)"
    />
  </template>
</template>
<script setup lang="ts">
import { isPriceProps, isSelectProps, isToggleProps, type AllFacets } from '~/types/facets';
import { isAggregationOption, isValidPriceValue } from '~/composables/facets';
/**
 * @description responsible for wrapping the facets object and render the selected facets based on the values selected
 */
defineProps<{
  facet: AllFacets;
  label: string;
}>();

const emit = defineEmits<{
  (e: 'removeSelectedFacet', value: { facet: AllFacets; value: string | null }): void;
}>();

function handleOnSelectItem(e: AllFacets, value: string | null) {
  if (isPriceProps(e)) {
    emit('removeSelectedFacet', {
      facet: e,
      value,
    });
    return;
  }
  if (isSelectProps(e)) {
    emit('removeSelectedFacet', {
      facet: e,
      value,
    });
    return;
  }

  emit('removeSelectedFacet', {
    facet: e,
    value,
  });
}
</script>
